<template>
  <section id="header">
    <nav
      id="nav_bar"
      class="navbar navbar-default "
      role="navigation"
    >
      <div class="container">
        <div class="navbar-header">
          <a
            id="logo"
            :class="['navbar-brand', headerFunc(bigHeader)]"
            href="/"
          />
        </div>
      </div>
    </nav>
  </section>
</template>

<script>
export default {
  name: 'HeaderCompo',
  props: { bigHeader: Boolean },
  methods: {
    headerFunc (bool) {
      if (bool === true) {
        return 'xl'
      } else {
        return 'ss'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
